import { render, staticRenderFns } from "./v-icon.vue?vue&type=template&id=51fb46dc&"
import script from "./v-icon.vue?vue&type=script&lang=ts&"
export * from "./v-icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports